export { default } from "./MasterProductsPage";
export * from "./types";
